module.exports = __webpack_public_path__ + "static/media/Default-authorization-logo.cf70c579.jpg";